import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
// import DashboardIcon from "@material-ui/icons/Dashboard";
import {
  getResources,
  MenuItemLink,
} from "react-admin";
import { arrayUniqueById, hasCurrentUserPermissionByName } from "../utils/utils";
import SubMenu from "./SubMenu";
import { MenuIsOpenState } from "../constants/menuCategories";
// import { RealTimeMenu } from "@react-admin/ra-realtime";
// import { RealTimeMenuItemLink } from "@react-admin/ra-realtime";
import { AUTH_TYPES } from '../auth/authConstants';
import { SERVER } from '../constants';
import { Badge } from "@mui/material";

const Menu = ({ onMenuClick, logout, dense }) => {
  const [state, setState] = useState(MenuIsOpenState);
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);
  const resourcesWithPermission = [];
  resources.forEach(item => {
    if (item.options.permissions) {
      let cont = true;
      item.options.permissions.forEach(el => {
        if (hasCurrentUserPermissionByName(el) && cont) {
          resourcesWithPermission.push(item);
          cont = false;
        }
      });
    }
    // if (hasCurrentUserPermissionByName(item.options.permission)) {
    //   resourcesWithPermission.push(item);
    // }
  });

  let categories = resourcesWithPermission.map(item => item.options.category);
  categories = arrayUniqueById(categories);
  const handleIsOpenMenuToggle = (menu) => {
    setState((state) => ({ ...state, [menu]: !state[menu] }));
  };

  const [needData, setNeedData] = useState({ needs: [] })
  const [notificationsData, setNotificationsData] = useState({ notifications: [] })


  const [loadingRequestData, setLoadingRequestData] = useState({ loadingRequests: [] })

  const [endpointCalled, setEndpointCalled] = useState(false);

  useEffect(() => {

    if (endpointCalled) {
      console.log("Endpoint was called!");
    }
    const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
    const urlNeed = `${SERVER}/admin/needUser`;
    const urlLoadingRequest = `${SERVER}/admin/loadingRequestUnit`;
    const urlNotif = `${SERVER}/admin/notificationsUnread`;

    function getNeedsOfUnitProcessor() {
      fetch(urlNeed, {
        headers: new Headers({
          'Authorization': `${token}`,
        }),
      })
        .then((data) => data.json())
        // .then((data) => setTableRows(data.rows))
        .then((data) => setNeedData(data))
        // .then((data) => tableColumns= data.columns)
        .then(setEndpointCalled(true))
    }
    function getNotificationsOfUser() {
      fetch(`${urlNotif}?filter={"unread": true}`, {
        headers: new Headers({
          'Authorization': token,
        }),
      })
        .then((data) => data.json())
        .then((data) => setNotificationsData(data))
        .then(() => setEndpointCalled(true)); // Use an arrow function to properly invoke
    }
        function getLoadingRequestOfUnit() {
      fetch(urlLoadingRequest, {
        headers: new Headers({
          'Authorization': `${token}`,
        }),

      })
        .then((data) => data.json())
        // .then((data) => setTableRows(data.rows))
        .then((data) => setLoadingRequestData(data))
        // .then((data) => tableColumns= data.columns)
        .then(setEndpointCalled(true))
    }

    getNeedsOfUnitProcessor()
    getLoadingRequestOfUnit();
    getNotificationsOfUser();

    const interval = setInterval(() => getNeedsOfUnitProcessor(), 5000)
    const interval2 = setInterval(() => getLoadingRequestOfUnit(), 5000)
    const interval3 = setInterval(() => getNotificationsOfUser(), 5000)

    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);

    }
  }, [endpointCalled])
  return (
    <div>
      {/* <MenuItemLink
        key={"dashboard"}
        to="/#"
        primaryText={"داشبورد"}
        leftIcon={<DashboardIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      /> */}
      <br></br>
      <br></br>

      {categories.map(category => {
        const categoryResources = resourcesWithPermission.filter(item => item.options.category.id === category.id);
        if (categoryResources.length === 1) {
          return <div style={{ marginRight: "12px" }}>
            {categoryResources.map(resource => (
              resource.name === "need" ?
                <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right', }} badgeContent={needData.length} color="error" max={9}>
                  <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={resource.options.label}
                    leftIcon={resource.icon}
                    resource={resource.name}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                  />
                </Badge>
                : resource.name === "loadingRequest" ?
                  <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right', }} badgeContent={loadingRequestData.length} color="error" max={9}>
                    <MenuItemLink
                      key={resource.name}
                      to={`/${resource.name}`}
                      primaryText={resource.options.label}
                      leftIcon={resource.icon}
                      resource={resource.name}
                      onClick={onMenuClick}
                      sidebarIsOpen={open}
                    />
                  </Badge>
                  : resource.name === "notifications" ?
                    <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right', }} badgeContent={notificationsData.length} color="error" max={9}>
                      <MenuItemLink
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={resource.options.label}
                        leftIcon={resource.icon}
                        resource={resource.name}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                      />
                    </Badge>

                    :
                    <MenuItemLink
                      key={resource.name}
                      to={`/${resource.name}`}
                      primaryText={resource.options.label}
                      leftIcon={resource.icon}
                      resource={resource.name}
                      onClick={onMenuClick}
                      sidebarIsOpen={open}
                    />
            ))}
          </div>
        } else {

          return <SubMenu
            handleToggle={() => handleIsOpenMenuToggle(category.id)}
            key={category.id}
            isOpen={state[category.id]}
            sidebarIsOpen={open}
            name={category.name}
            dense={dense}
            icon={category.icon}
          >

            {categoryResources.map(resource => (
              <MenuItemLink
                key={resource.name}
                to={`/${resource.name}`}
                primaryText={resource.options.label}
                leftIcon={resource.icon}
                onClick={onMenuClick}
                resource={resource.name}
                sidebarIsOpen={open}
              />
            ))}
          </SubMenu>;
        }
      })}
      {/* <div style={{ position: 'absolute', bottom: '4%', right: '4%' }}>
        {logout}
      </div> */}
    </div>
  );
}

Menu.propTypes = {
  onMenuClick: PropTypes.func,
  logout: PropTypes.object,
};

export default Menu;
